import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAU = function FlagAU() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#0052B4",
    d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25C0 25.006 25 .003 25 0c13.807 0 25 11.193 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 0h-.004H25ZM24.933 24.999H25v-.067l-.067.067Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 13.046V.003h-.004C11.19.005 0 11.197 0 25.003h13.043v-7.346l7.345 7.345h4.545l.067-.066V20.39l-7.345-7.345H25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "M12.648 3.262a25.12 25.12 0 0 0-9.387 9.387V25h6.522V9.784H25V3.262H12.648Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "m25 21.926-8.882-8.882h-3.074L25 25v-3.074Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "m15.078 29.35 1.372 2.868 3.098-.716-1.387 2.861 2.491 1.976-3.102.7.009 3.18-2.481-1.99-2.481 1.99.008-3.18-3.102-.7 2.492-1.976-1.388-2.861 3.099.716 1.372-2.869ZM37.43 34.783l.686 1.434 1.55-.358-.694 1.431 1.245.988-1.55.35.003 1.59-1.24-.995-1.24.995.004-1.59-1.551-.35 1.246-.988-.694-1.43 1.55.358.685-1.435ZM31.048 19.566l.686 1.435 1.55-.359-.694 1.431 1.245.988-1.55.35.004 1.59-1.24-.995-1.241.995.004-1.59-1.551-.35 1.246-.988-.694-1.43 1.55.358.685-1.435ZM37.43 10.87l.686 1.435 1.55-.358-.694 1.43 1.245.988-1.55.35.003 1.59-1.24-.995-1.24.995.004-1.59-1.551-.35 1.246-.988-.694-1.43 1.55.358.685-1.435ZM43.005 17.392l.686 1.434 1.549-.358-.694 1.43 1.246.989-1.551.35.004 1.59-1.24-.995-1.24.994.003-1.59-1.55-.35 1.245-.987-.694-1.431 1.55.358.686-1.434ZM39.019 25l.54 1.66h1.745l-1.412 1.027.54 1.66-1.413-1.026-1.413 1.027.54-1.66-1.413-1.027h1.746l.54-1.661Z"
  }));
};
FlagAU.displayName = 'FlagAU';
export default withFlagWrapper(FlagAU);
//# sourceMappingURL=index.js.map